/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import TextBlock from "../../useful/TextBlock"
import { ICardFieldProps } from "../cards/CardField"

const CardFieldHTML = (props: ICardFieldProps): JSX.Element => {
    const { value, field, section, i } = props
    useEffect(() => { 
        addCSSClass(
            `landing-card-field-html-${section.id + "-" + value?.id}`,
            `.landing-card-field-html-${section.id + "-" + value?.id} {
                
            }`
        )
        return () => removeCSSClass(`landing-card-field-html-${section.id + "-" + value?.id}`)
    }, []) 
    const style = { 
        ...field.style, 
        ...value.style 
    }
    style.backgroundColor = undefined
    return <div 
        className={`landing-card-field landing-card-field-html landing-card-field-html-${section.id + "-" + value.id} ${value.className}`}  
        style={ style }
        data-card-field-id={i} 
        card-field-section-id={section.id}
    >  
        <TextBlock 
            editType={ SELECT_TYPE.CARD_FIELD_HTML }
            section={ section }
            data={ props }
            columns={ 1 }
            text={ value.data || ""}
            className={ ` medallion-padder` }
            max_length={ value.data?.max_length || field.max_length } 
        /> 
    </div>
}
export default CardFieldHTML